import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./global";
import userReducer from "./user/user";
import bankReducer from "./bank/bank";
import investmentsReducer from "./investments/investments";
import featureflagReducer from "./featureflag/featureflag";
import iyiPortfolioReducer from "./iyiPortfolio/iyiPortfolio";
import techexcelReducer from "./techExcel/techExcel";

const store = configureStore({
  reducer: {
    global: globalReducer,
    user: userReducer,
    bank: bankReducer,
    investments: investmentsReducer,
    featureflag:featureflagReducer,
    iyiPortfolio: iyiPortfolioReducer,
    techExcel: techexcelReducer
  },
});

export default store;
